import {ContactLeg, Device, EventBusInstance, LogLevel} from "@sap/cpaas-commlib-lib";
import {IChatMessage, IChatQueue, LaunchPadConfig} from "../utils/types";

function getDefaultEndpoint() {
	const url = window.location.href.split("/");
	return (url.indexOf("ecf") !== -1 ? url.slice(0, url.indexOf("ecf")).join("/") : location.origin) + "/ecfs";
}

export abstract class Configuration {
	static endpoint: string = getDefaultEndpoint();
	static tenantId: string = "";
	static locale: string = window.navigator.language || "en";
	static i18nCustomFileUrl: false|string = false;
	static chatQueues: IChatQueue[] = [];
	static queues: Array<{ address: string, id: string, name: string }> = [];
	static component: string = "com.sap.ec.visitor";
	static event: string = "Configuration";
	static sizeEvent: string = "SizeEvent"; // Fired on browser resize, when iFrame size was changed as result (user decreasing size)
	static sizeEventFrameNotResized: string = "sizeEventFrameNotResized"; // Fired on browser resize, but when iFrame size was not changed as result (user increasing size)
	static startWebChatEvent: string = "StartWebChat";
	static startLaunchpadEvent: string = "StartLaunchpad";	
	static allMessagesRecoveredEvent: string = "allMessagesRecovered";
	static mockServer: boolean = false;
	static showLogin: boolean = false;
	static mandatoryLogin: boolean = false;
	static useVideo: boolean = false;
	static saveTranscript: boolean = false;
	static soundNotification: boolean = false;
	static notificationFile: string = "";
	static maxHeight: number = 800;
	static maxWidth: number = 400;
	static theme: string;
	static logLevel: LogLevel = LogLevel.ERROR;
	static userName: string;
	static userAddress: string;
	static cad: object;
	static incoming: boolean;
	static launchpad: LaunchPadConfig;
	static upgradeToWebChat: string = "Upgrade";
	static minimizeEvent: string = "minimizeEvent";
	static isMobile: boolean = false;
	static initialClientWidth: number;
	static initialClientHeight: number;
	static orientationChange: string = "orientationChange";

	static setProperty(property: string, value: any) {
		const item = FromEnum(property, Parameter);
		if (item) {
			if (property === Parameter.endpoint && value[value.length - 1] === "/") {
				value = value.substr(0, value.length - 1);
			}
			(Configuration as any)[item] = value;
			EventBusInstance.publish(Configuration.event, [property], Configuration.component);
		}
	}

	static setProperties(properties: any) {
		const keys = [];
		for (const property in properties) {
			if (properties.hasOwnProperty(property)) {
				const item = FromEnum(property, Parameter);
				if (item) {
					let value = properties[property];
					if (property === Parameter.endpoint && value[value.length - 1] === "/") {
						value = value.substr(0, value.length - 1);
					}
					(Configuration as any)[item] = value;
					keys.push(property);
				}
			}
		}
		if (keys.length > 0) {
			EventBusInstance.publish(Configuration.event, keys, Configuration.component);
		}
	}
}

export const AppState: { width: number, height: number, activeLeg: ContactLeg, activeDevice: Device, language: string, selectedQueue: string, messages:IChatMessage[], disconnecting: boolean, visitorUserId: undefined|string } = {
	activeLeg: undefined,
	activeDevice: undefined,
	width: Configuration.maxWidth - 1,
	height: Configuration.maxHeight - 1,
	language: "en",
	selectedQueue: undefined,
	messages:[],
	disconnecting: false,
	visitorUserId: undefined
};

export function FromEnum(property: any, enumeration: any): string {
	return Object.keys(enumeration).filter((key: any) => enumeration[key] === property)[0];
}

export enum Parameter {
	endpoint = "ep", chatQueues = "cq", locale = "lc", i18nCustomFileUrl = "cu", mockServer = "ms", logLevel = "ll", showLogin = "sl", mandatoryLogin = "ml", useVideo = "uv", parentUri = "pu", maxWidth = "aw", maxHeight = "ah", tenantId = "ti",
	theme = "th", userName = "un", userAddress = "ua", queues = "qu", cad = "ca", incoming = "ic", saveTranscript = "st", soundNotification = "sn", notificationFile = "fn", launchpad = "lp", isMobile = "im", initialClientWidth = "cw", initialClientHeight = "ch"
}
